import { type PdpPageProductData } from "~/features/productDetails/models/PdpPageProductData";
import { useAddProductToWishlistFlow } from "~/features/wishlist/hooks/useAddProductToWishlistFlow";
import { type OptionalPartFormData } from "~/features/addToCart/hooks/useAddToCartNew";
import { Button, type ButtonProps } from "~/common/mui";
import { type MouseEventHandler, useCallback } from "react";
import { IconType } from "~/common/components/icon/IconType";
import { useTranslation } from "react-i18next";
import { DefaultButtonIcon } from "~/common/components/icon/Icon";

interface Props extends ButtonProps {
  product: PdpPageProductData;
  selectedOptionalParts?: Dict<OptionalPartFormData>;
}

export const PdpAddToWishlist = ({ product, selectedOptionalParts, onClick: externalOnClick, ...rest }: Props) => {
  const [openWishlistModal, modal] = useAddProductToWishlistFlow({
    productInput: product,
    selectedOptionalParts,
  });
  const { t } = useTranslation();

  const onClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      externalOnClick?.(e);
      openWishlistModal();
    },
    [externalOnClick],
  );

  return (
    <>
      <Button
        startIcon={<DefaultButtonIcon type={IconType.Bookmark} />}
        onClick={onClick}
        data-test-id={"add-to-wishlist"}
        {...rest}
      >
        {t("basket.addToWishlist")}
      </Button>
      {modal}
    </>
  );
};
